// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"8a2346ea","977":"8cb7982e"}[chunkId] + ".chunk.js";
};